import(/* webpackMode: "eager", webpackExports: ["CopyTraderButton","FollowTraderButton","WhaleShareBar","WhaleCta","WhaleRetry"] */ "/opt/buildhome/repo/app/w/whale-share.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@14.2.5_@opentelemetry+api@1.10.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
